// src/store/index.ts
import { configureStore } from "@reduxjs/toolkit";
import { bookingWizardReducer, authReducer } from "./slices";

export const store = configureStore({
  reducer: {
    bookingWizard: bookingWizardReducer,
    auth: authReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
